
document.addEventListener("DOMContentLoaded", function () {
  const allDetails = document.querySelectorAll(".cart-bundle-details");

  allDetails.forEach((details) => {
    const summary = details.querySelector("summary");
    const content = details.querySelector(".product-bundle");
    const showMore = details.querySelector(".cart-bundle-show-more");
    const showLess = details.querySelector(".cart-bundle-show-less");

    // Set initial state
    let isOpen = details.open;
    content.style.maxHeight = isOpen ? `${content.scrollHeight}px` : "0px";
    content.style.opacity = isOpen ? "1" : "0";
    content.style.overflow = "hidden";
    content.style.transition =
      "max-height 0.3s ease-out, opacity 0.3s ease-out";

    summary.addEventListener("click", function (e) {
      e.preventDefault(); // Prevent the default toggle behavior

      isOpen = !isOpen;

      if (isOpen) {
        details.setAttribute("open", "");
        content.style.maxHeight = `${content.scrollHeight}px`;
        content.style.opacity = "1";
        showMore.style.display = "inline";
        showLess.style.display = "none";
      } else {
        content.style.maxHeight = "0px";
        content.style.opacity = "0";
        showMore.style.display = "none";
        showLess.style.display = "inline";

        // Remove the 'open' attribute after the transition
        setTimeout(() => {
          details.removeAttribute("open");
        }, 300); // This should match the transition duration
      }
    });
  });
});